import React from 'react';
import HeroVideo from '../components/landing/HeroVideo';
import ProductBento from '../components/landing/ProductBento';
import { FounderStory, HowWeWork } from '../components/landing/FounderAndSteps';
import LampJourney from '../components/landing/LampJourney';
import { CompareTable, HomeFaqAndVisit, ReviewsAndPartners, SipTeaser } from '../components/landing/HomeLowerSections';
import { usePageTitle } from '../components/layout/PageBits';

// Each section has its own look; only the hero is "special" (video / aurora).
function HomePage() {
  usePageTitle(null);
  return (
    <>
      <HeroVideo />
      <ProductBento />
      <FounderStory />
      <HowWeWork />
      <LampJourney />
      <CompareTable />
      <SipTeaser />
      <ReviewsAndPartners />
      <HomeFaqAndVisit />
    </>
  );
}

export default HomePage;
